
import React, { useState } from 'react';
import classnames from 'classnames';
import WysiwygField from '../../../WysiwygField';
import './style.scss';

const CollapsableGeneric = ({ title, body, className, index, roundedIcon }) => {

  const [OpenAnswer, setOpenAnswer] = useState(false);

  const toggleAnswer = () => {
    setOpenAnswer(!OpenAnswer);
  };

  return (
    <div
      className={classnames(className, 'Collapsable', { Collapsable__open: OpenAnswer })}
      onClick={toggleAnswer}
    >
      <div className="Collapsable__container">
        <div className={classnames(className, 'icon icon-plus icon-variant-0', { icon__rounded: roundedIcon })} />
        <strong className="Collapsable__title">{title}</strong>
      </div>
      <div className={classnames('Collapsable__body', { Collapsable__body__rounded: roundedIcon })}>
        {body && (
          <WysiwygField
            property="schema:text"
            html={body}
            className="subheading2"
          />
        )}
      </div>
    </div>
  );
};

export default CollapsableGeneric;
